/* eslint-disable max-len */
import {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import FormDeliveryComponent from "../../components/Forms/FormDelivery";
import CartCard from "../../components/cartCard/CartCard";
import styles from "./CheckoutEndEntrega.module.css";
import { Header } from "../../components/Header";
import { useCheckout } from "../../context/CheckoutContext";
import { Constants } from "../../utils/constants";
import { ecommerceEvents } from "../../utils/gtm";

const CheckoutEndEntrega: FunctionComponent = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const width = window.innerWidth;
  const cartCardRef = useRef(null);
  const [isCartCardVisible, setIsCartCardVisible] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [errors, setErros] = useState({
    cepError: "",
    allFieldsError: "",
  });

  const { 
    cart,
    clientAndAffiliate,
    purchaser,
    totalPrice,
    coupon,
    planName,
    planId,
    setAddressData, 
    address 
  } = useCheckout();

  useEffect(() => {
    if (cart.length === 0) params.slug ? navigate(`/${params.slug}`) : navigate("/")
    const elemento = document.getElementById('entrega');
    if (elemento) {
      elemento.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    const purchaserDataInLocalStorage =
      localStorage.getItem(Constants.LOCALSTORAGE.purchaserData);

    if (!purchaserDataInLocalStorage) {
      params.slug
        ? navigate(`/checkout-dados/${params.slug}`)
        : navigate('/checkout-dados');
    }

  },[navigate])

  const couponURL = searchParams.get('cupom');
  const onSeusDadosTextClick = useCallback(() => {
    if (!params.slug && !params.planSlug) {
      navigate(`/checkout-dados${couponURL ? `?cupom=${couponURL}` : ''}`);
    } else if (params.slug && !params.planSlug) {
      navigate(`/checkout-dados/${params.slug}${couponURL ? `?cupom=${couponURL}` : ''}`)
    } else if (params.slug && params.productSlug) {
      navigate(`/checkout-dados/${
          params.slug
        }/${params.planSlug}/${params.productSlug}
        ${couponURL ? `?cupom=${couponURL}` : ''}`)
    } else if (params.planSlug && params.productSlug) {
      navigate(`/checkout-dados/${params.planSlug}/${params.productSlug}
        ${couponURL ? `?cupom=${couponURL}` : ''}`)
    }
  }, [navigate]);

  const openCartCardModal = () => {
    setIsCartCardVisible(!isCartCardVisible);
  };
  useEffect(() => {
    // Adicione um event listener para detectar cliques fora do modal
    const handleClickOutside = (event) => {
      if (cartCardRef.current && !cartCardRef.current.contains(event.target)) {
        setIsCartCardVisible(false);
      }
    };

    // Adicione o event listener quando o modal estiver visível
    if (isCartCardVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      // Remova o event listener ao desmontar o componente
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCartCardVisible]);

  const handleSubmitForm = () => {
    setAddressData(address);
    localStorage.setItem(
      Constants.LOCALSTORAGE.cepData,
      JSON.stringify(address)
    );
    
    // Enviar dados para o GTM
    ecommerceEvents.addShippingInfo({
      currency: "BRL",
      value: totalPrice,
      shipping_tier: "free",
      coupon: coupon.name? coupon.name : "",
      email: purchaser.email,
      phone: purchaser.telephone.replace(/[()\-\s]/g, ''),
      first_name: purchaser.name,
      last_name: purchaser.lastname,
      afiliado: params.slug? params.slug : clientAndAffiliate.affiliate_id? clientAndAffiliate.affiliate_id : "",
      items: cart.map(item => ({
        item_id: item.id,
        item_name: item.name,
        price: item.price,
        quantity: item.quantity,
        promotion_id: planId,
        promotion_name: planName,
      })),
      shipping_address: {
        city: address.cidade,
        street: address.logradouro,
        number: address.numero,
        state: address.estado,
        neighborhood: address.bairro,
        postal_code: address.cep,
        complement: address.complemento,
      }
    });

    if (Object.values(errors).every((x) => x === "")) {
      if (!params.slug && !params.planSlug) {
        navigate(`/checkout-pagamento${couponURL ? `?cupom=${couponURL}` : ''}`);
      } else if (params.slug && !params.planSlug) {
        navigate(`/checkout-pagamento/${params.slug}
          ${couponURL ? `?cupom=${couponURL}` : ''}`)
      } else if (params.slug && params.productSlug) {
        navigate(`/checkout-pagamento/${
            params.slug
          }/${params.planSlug}/${params.productSlug}
          ${couponURL ? `?cupom=${couponURL}` : ''}`)
      } else if (params.planSlug && params.productSlug) {
        navigate(`/checkout-pagamento/${params.planSlug}/${params.productSlug}
          ${couponURL ? `?cupom=${couponURL}` : ''}`)
      }
    }
  };

  const changeErrors = (value: {
    cepError: string,
    allFieldsError: string,
  }) => {
    setErros(value)
  }

  const changeDisabled = (value:boolean) => {
    setDisabled(value)
  }

  return (
    <div className={styles.checkoutEndEntrega}>
      {/* <div className={styles.header}> */}
        <Header path="/checkout-dados" />
      {/* </div> */}
      <div className={styles.conteudo}>
        <div className={styles.colunaDireita}>
          <div className={styles.titulo}>
            <div className={styles.seusDados} onClick={onSeusDadosTextClick}>
              Seus dados
            </div>
            <div className={styles.div}>{`>`}</div>
            <div id="entrega"
             className={styles.endereoDeEntrega}>Endereço de entrega</div>
            <div className={styles.pagamento}>{`>`}</div>
            <div className={styles.pagamento}>Pagamento</div>
          </div>
          <FormDeliveryComponent
            setErros={changeErrors}
            errors={errors}
            disabled={disabled}
            setDisabled={changeDisabled}
            handleSubmitForm={handleSubmitForm}
          />
        </div>
        {width > 800 ? (
          <div className={styles.colunaEsqueda}>
            <CartCard showProducts={true} />
          </div>
        ) : (
          <>
            <div className={styles.cartIconBox} onClick={openCartCardModal}>
              <svg
                className={styles.cartIcon}
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                width="27"
                viewBox="0 0 576 512"
              >
                <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/>
              </svg>
            </div>
            {/* <div className={styles.botao4} onClick={openCartCardModal}>
              <div className={styles.cta10}>
                <img className={styles.icones132} alt="" src="/icones4.svs" />
                <div className={styles.continuarCompra24}>Continuar para pagamento</div>
                <img className={styles.icones133} alt="" src="/icones5.svg" />
              </div>
            </div> */}
          </>
        )}

        {!isCartCardVisible && width < 800 && (
          <div className={disabled ? styles.cta : styles.filledCart} 
            onClick={handleSubmitForm}>
            <div className={styles.continuarCompra24}>
              <button
                className={styles.btnContinuarCompra}
                disabled={disabled}
                onClick={handleSubmitForm}
              >
                Continuar para pagamento
              </button>
            </div>
            <img className={styles.icones133} alt="" src="/icones5.svg" />
          </div>
        )}
        {isCartCardVisible && width < 800 && (
          <div
            className={`${styles.cartCardModal} ${
              isCartCardVisible ? styles.showModal : ""
            }`}
          >
            <div className={styles.cartCardContent} ref={cartCardRef}>
              <CartCard showProducts={true} />
              <div 
                className={styles.cta1}
                onClick={openCartCardModal}
                style={{borderRadius: 0}}
              >
                <div className={styles.yelly}>Voltar</div>
                {/* <img className={styles.icones18} alt="" src="/icones4.svg" /> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckoutEndEntrega;
